export const NPA_COMMON_DIALOG_WIDTH = '800px';
export const NPA_COMMON_WIDE_DIALOG_WIDTH = '1000px';
export const NPA_COMMON_DIALOG_HEIGHT = '80%';
